<template>
    <app-modal-view @close="$emit('close')">
        <template #header>
            <div
                :style="`${background(project.background)}`"
                class="lb-project-modal-header"
            >
                <p
                    aria-label="close"
                    class="lb-modal-close has-text-white"
                    @click="$emit('close')"
                >
                    <span class="icon is-large">
                        <i class="mdi mdi-close mdi-24px"></i>
                    </span>
                </p>
            </div>
        </template>
        <template #body>
            <div class="lb-modal-resume-project-title">
                <p
                    class="has-text-weight-bold is-size-5-mobile is-size-4-tablet is-family-secondary has-text-centered is-marginless"
                >
                    {{ project.title }}
                </p>
                <div class="buttons pl-3">
                    <button class="button is-white" @click="$emit('share')">
                        <span class="icon is-medium">
                            <i class="mdi mdi-24px mdi-share-variant"></i>
                        </span>
                    </button>
                    <button
                        :class="{
                            'has-text-primary': project.liked,
                        }"
                        class="button is-white"
                        @click="toggleLike"
                    >
                        <span class="icon is-medium is-primary">
                            <i
                                :class="{
                                    'mdi-thumb-up-outline': !project.liked,
                                    'mdi-thumb-up': project.liked,
                                }"
                                class="mdi mdi-24px"
                            ></i>
                        </span>
                    </button>
                </div>
            </div>
            <nav class="columns is-mobile is-centered is-marginless">
                <div class="column is-narrow has-text-centered">
                    <p class="has-text-weight-bold pr-1 is-size-5">
                        {{ project.views || 0 }}
                    </p>
                    <p v-t="'Project.resume_views'"></p>
                </div>
                <div class="column is-narrow has-text-centered">
                    <p class="has-text-weight-bold pr-1 is-size-5">
                        {{ project.likes || 0 }}
                    </p>
                    <p v-t="'Project.resume_likes'"></p>
                </div>
                <div class="column is-narrow has-text-centered">
                    <p class="has-text-weight-bold pr-1 is-size-5">
                        {{ project.participants || 0 }}
                    </p>
                    <p v-t="'Project.resume_participants'"></p>
                </div>
            </nav>
            <slot name="navigationButtons">
                <div v-if="showNavigationButtons" class="buttons is-centered">
                    <router-link
                        v-t="'Project.resume_action_access'"
                        :to="{
                            name: 'project',
                            params: { projectId: project._id },
                        }"
                        tag="a"
                        class="button is-primary has-text-weight-bold px-6"
                    >
                    </router-link>
                </div>
            </slot>
            <p class="pt-1 pb-4">
                {{ project.description }}
            </p>
            <span>
                <strong v-t="'Project.privacy'"></strong>
                {{ $t(`projectConfiguration.privacy_${project.privacy}`) }}
            </span>
            <div class="pt-4">
                <p class="has-text-weight-bold pr-1">
                    {{ project.owner.username }}
                </p>
                <p>
                    {{ $t('Project.created_at') }} {{ formattedCreationDate }}
                </p>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { projectBackground } from '@/lib/helpers';
import { likeProject } from '@/services/API';
import _ from 'underscore';
import moment from 'moment';
export default {
    components: {
        AppModalView,
    },
    props: {
        projectSource: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
        showNavigationButtons: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            project: this.projectSource,
        };
    },
    computed: {
        background() {
            return (bg) => {
                return projectBackground(
                    !_.isEmpty(this.project.image)
                        ? this.project.image
                        : !_.isEmpty(this.project.backgroundImage)
                        ? this.project.backgroundImage
                        : bg
                );
            };
        },
        formattedCreationDate() {
            moment.locale('es');
            return moment(this.project.created).format('DD MMMM YYYY');
        },
        canEdit() {
            return this.project.accessLevel != 'read';
        },
    },
    methods: {
        async toggleLike() {
            let likeResult = await likeProject(this.project._id);
            this.project = likeResult.data;
        },
    },
};
</script>

<style scoped>
.lb-project-modal-header {
    height: 200px;
    margin: -20px;
}
.lb-project-modal-header .image {
    height: 100%;
}
.lb-project-modal-header img {
    object-fit: cover;
    border-radius: 4px;
}
.lb-modal-resume-project-title {
    display: flex;
    justify-content: center;
    align-items: center;
}
.lb-modal-close {
    left: 1rem;
    top: 1rem;
    position: absolute;
    background-color: transparent;
    border-color: transparent;
    text-shadow: 0px 2px 4px #000;
    cursor: pointer;
}
</style>
